import { combineReducers } from 'redux';
import user from '../user/userReducer';
import licenses from '../licenses/licenseReducer';
import orders from '../orders/ordersReducer';
import companyFeatures from '../companyFeatures/companyFeaturesReducer';
import account from '../account/accountReducer';

const rootReducer = combineReducers({
  orders,
  licenses,
  user,
  companyFeatures,
  account,
});

export default rootReducer;
